import "../ContentPages/style.css";
import Verified from "../../assets/images/Verified.svg";
import Camera from "../../assets/images/Camera.svg";
import Computer from "../../assets/images/Computer.svg";
import SubmitButton from "../Buttons/SubmitButton";
import CancelButton from "../Buttons/CancelButton";
import { useForm } from "react-hook-form";
import { redirectToRealMe } from "../../Services/apiService.jsx";
import FieldError from "../FieldError/index.jsx";

const Apply = ({ handleNext }) => {
  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm({
    mode: "onTouched",
  });

  const onSubmit = () => {
    handleNext();
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="intro">
          <h1 className="intro-title-mi" style={{ marginTop: 60 }} lang="mi-NZ">
            Tono i tētahi tuakiri hāpono
          </h1>
          <hr />
          <h1 className="intro-title">Apply for your verified identity</h1>

          <div className="step-container">
            <h2 className="step-title mb-4">How it works </h2>
            <div className="step-wrapper">
              <div className="step-imgbx">
                <img src={Verified} alt="" />
              </div>
              <div>
                <h3 className="step-heading mb-2">1. Tell us who you are</h3>
                <p className="step-text">
                  Provide the details from <strong>one</strong> of the following
                  official identity documents.
                </p>
                <ul className="step-listing">
                  <li className="step-item">
                    <span className="hover-container">
                      NZ passport
                      <span className="hover-tooltip">
                        You can use an expired passport.
                      </span>
                    </span>
                  </li>
                  <li className="step-item">NZ birth certificate</li>
                  <li className="step-item">NZ citizenship certificate</li>
                  <li className="step-item">
                    Overseas passport or NZ immigration travel document
                  </li>
                </ul>
              </div>
            </div>
            <div className="step-wrapper align-items-center">
              <div className="step-imgbx">
                <img src={Camera} alt="" />
              </div>
              <h3 className="step-heading mb-0">
                2. Take a live photo using your device
              </h3>
            </div>
            <div className="step-wrapper align-items-center">
              <div className="step-imgbx">
                <img src={Computer} alt="" />
              </div>
              <h3 className="step-heading mb-0">
                3. In some cases, you'll need an identity referee to confirm
                your details
              </h3>
            </div>
          </div>

          <h2 className="step-title mb-2">Terms of use</h2>
          <div className="checkbox-wrapper">
            <input
              type="checkbox"
              id="terms-checkbox"
              className="terms-check"
              {...register("terms", {
                required: "You must accept the terms to proceed.",
              })}
            />
            <label className="terms-label" htmlFor="terms-checkbox">
              I accept the{" "}
              <a href="https://www.realme.govt.nz/terms-use/identity-verification-service-terms-use/">
                RealMe Verified Identity Terms of use
              </a>
              <span className="req-text">*</span>
            </label>
          </div>
          {errors?.terms && <FieldError error={errors?.terms} info={null} />}
        </div>
        <div className="step-button-container spacer-64">
          <SubmitButton
            text={"Get Started"}
            type="submit"
            disabled={!isValid}
          />
          <CancelButton text={"Cancel"} onClick={redirectToRealMe} />
        </div>
      </form>
    </>
  );
};

export default Apply;
